import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Home() {
  const { currentUser } = useAuth();

  const dashboardPath =
    currentUser?.userType === 'rider'
      ? '/rider/dashboard'
      : currentUser?.userType === 'driver'
        ? '/driver/dashboard'
        : currentUser?.userType === 'admin'
          ? '/admin/dashboard'
          : null;

  if (currentUser && dashboardPath) {
    return <Navigate to={dashboardPath} replace />;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center">
        <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
          <span className="block">Welcome to</span>
          <span className="block text-indigo-600">Chariots of Fire</span>
        </h1>
        <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
          Building community through shared journeys to worship. Connect with fellow church members for safe, reliable transportation to services and events.
        </p>

        <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
          <div className="rounded-md shadow">
            <Link
              to="/register"
              className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10"
            >
              Join Our Community
            </Link>
          </div>
          <div className="mt-3 sm:mt-0 sm:ml-3">
            <Link
              to="/login"
              className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50 md:py-4 md:text-lg md:px-10"
            >
              Sign In
            </Link>
          </div>
        </div>
      </div>

      <div className="mt-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg font-medium text-gray-900">For Riders</h3>
              <div className="mt-2 text-sm text-gray-500">
                <ul className="list-disc pl-5 space-y-1">
                  <li>Find rides to church services</li>
                  <li>Connect with fellow church members</li>
                  <li>Never miss worship again</li>
                  <li>Safe and reliable community transport</li>
                  <li>Build friendships through shared journeys</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg font-medium text-gray-900">For Volunteer Drivers</h3>
              <div className="mt-2 text-sm text-gray-500">
                <ul className="list-disc pl-5 space-y-1">
                  <li>Serve your church community</li>
                  <li>Help members attend worship services</li>
                  <li>Flexible volunteer opportunities</li>
                  <li>Make a difference in people's lives</li>
                  <li>Build fellowship through service</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg lg:col-span-1 md:col-span-2">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg font-medium text-gray-900">Our Mission</h3>
              <div className="mt-2 text-sm text-gray-500">
                <p className="mb-3">
                  <strong>"Carry each other's burdens, and in this way you will fulfill the law of Christ."</strong> - Galatians 6:2
                </p>
                <p>
                  Chariots of Fire connects our church family through the spirit of service and fellowship.
                  Our volunteer drivers generously share their time and vehicles to ensure every member can
                  participate in worship, Bible study, and community events.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 bg-indigo-50 rounded-lg px-6 py-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-indigo-900 mb-4">
            Join Our Transportation Ministry
          </h2>
          <p className="text-indigo-700 mb-6 max-w-2xl mx-auto">
            Whether you need a ride or can offer one, you're contributing to our church community.
            Together, we ensure that transportation is never a barrier to worship and fellowship.
          </p>
          <Link
            to="/register"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Get Started Today
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
